module.exports = __webpack_public_path__ + "img/icon_call.97cb25a6.svg";